/**
 * The app-shell rem literals, restated in px so they do not depend on the document root.
 *
 * `src/shared/styles/antd-global.css` pins the root to 10px and the other values are calibrated for that.
 * Some micro-apps inject their own root font-size, which would otherwise break the app-shell rem calculations.
 */

// TODO: fix micro app

/** The root font-size the app-shell rem literals are calibrated against. */
const APP_SHELL_REM_BASE = 10;

/**
 * `rem(2)` is what `2rem` renders as under the app-shell own root.
 *
 * Rounded because the multiplication is binary floating point: `0.14 * 10` is
 * `1.4000000000000001`, which would reach the stylesheet verbatim. Three decimals
 * keeps every sub-pixel value the app-shell actually uses (`12.5px`, `11.25px`).
 */
export function rem(value: number): string {
  return `${Number((value * APP_SHELL_REM_BASE).toFixed(3))}px`;
}
